import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";

const CalificadorSIGEDI = ({
  aulaID,
  idAsignacionMateria,
  idInstancia,
  idCurso,
  cierro,
}) => {
  const [alumnos, setAlumnos] = useState([]);
  const [notas, setNotas] = useState({});
  const Usuaio = ObtieneDatosCookies();

  const selectRefs = useRef({});

  const normalizarTexto = (valor = "") =>
    String(valor || "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  const contieneFinal = (valor) => {
    if (!valor) return false;

    if (typeof valor === "string") {
      const texto = normalizarTexto(valor);

      if (texto.includes("final")) return true;

      try {
        const json = JSON.parse(valor);
        return contieneFinal(json);
      } catch {
        return false;
      }
    }

    if (Array.isArray(valor)) {
      return valor.some((x) => contieneFinal(x));
    }

    if (typeof valor === "object") {
      return Object.values(valor).some((x) => contieneFinal(x));
    }

    return false;
  };

  const exclusivoReal = contieneFinal(idInstancia?.exclusivo)
    ? null
    : idInstancia?.exclusivo || null;

  const esInstanciaFinal = contieneFinal(idInstancia?.exclusivo);

  const obtenerDnisPermitidosExclusivo = (exclusivo, idMateria) => {
    try {
      if (!exclusivo) return null;

      const exclusivoJSON =
        typeof exclusivo === "string" ? JSON.parse(exclusivo) : exclusivo;

      let dniPermitidos = exclusivoJSON[idMateria] || [];

      if (!Array.isArray(dniPermitidos)) {
        if (typeof dniPermitidos === "string") {
          dniPermitidos = dniPermitidos
            .split(/[\s,;]+/)
            .map((dni) => dni.trim())
            .filter(Boolean);
        } else {
          dniPermitidos = [dniPermitidos].filter(Boolean);
        }
      }

      return dniPermitidos.map((dni) => String(dni));
    } catch (error) {
      console.error("Error parseando exclusivo JSON:", error);
      return null;
    }
  };

  useEffect(() => {
    if (aulaID) fetchAlumnos();
  }, [aulaID, idInstancia?.id, idAsignacionMateria?.id]);

  const fetchAlumnos = async () => {
    try {
      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/devuelveAlumnosCursos`,
        { idCurso: idCurso, division: aulaID }
      );

      const response2 = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/devuelveAlumnosConNotas/?&aulaID=${idAsignacionMateria.id}&idInstancia=${idInstancia.id}`
      );

      let alumnosData = response.data;

      if (exclusivoReal) {
        const dnisPermitidos = obtenerDnisPermitidosExclusivo(
          exclusivoReal,
          idAsignacionMateria.idMateria
        );

        if (Array.isArray(dnisPermitidos)) {
          alumnosData = alumnosData.filter((al) =>
            dnisPermitidos.includes(String(al.alumnoDni))
          );
        }
      }

      setAlumnos(alumnosData);

      const notasIniciales = {};

      alumnosData.forEach((alumno) => {
        const notaExistente = response2.data.find(
          (n) => String(n.alumnoDni) === String(alumno.alumnoDni)
        );

        notasIniciales[alumno.alumnoDni] =
          notaExistente?.nota !== null && notaExistente?.nota !== undefined
            ? notaExistente.nota
            : "";
      });

      setNotas(notasIniciales);
    } catch (error) {
      console.error("Error al obtener alumnos:", error);
      Swal.fire("Error", "No se pudieron obtener los alumnos.", "error");
    }
  };

  const handleNotaChange = (alumnoDni, nota) => {
    setNotas((prev) => ({ ...prev, [alumnoDni]: nota }));
  };

  const handleKeyDown = (e, alumnoDni, index) => {
    if (idInstancia.tipoCalificacion === "Numerica") {
      if (/^[0-9]$/.test(e.key)) {
        handleNotaChange(alumnoDni, e.key);

        const next = alumnos[index + 1];

        if (next) {
          setTimeout(() => {
            selectRefs.current[next.alumnoDni]?.focus();
          }, 50);
        }
      }
    }

    if (e.key === "Enter") {
      e.preventDefault();

      const next = alumnos[index + 1];

      if (next) {
        selectRefs.current[next.alumnoDni]?.focus();
      }
    }
  };

  const enviarDatos = async () => {
    const datosAEnviar = alumnos
      .filter(
        (alumno) =>
          notas[alumno.alumnoDni] !== undefined &&
          notas[alumno.alumnoDni] !== "" &&
          notas[alumno.alumnoDni] !== null
      )
      .map((alumno) => ({
        idAsignacionMateria: idAsignacionMateria.id,
        alumnoDni: alumno.alumnoDni,
        idInstancia: idInstancia.id,
        nota: notas[alumno.alumnoDni],
        estado: "Activo",
        califico: "SIGEDI_NI:" + Usuaio.identificacion,
      }));

    if (datosAEnviar.length === 0) {
      Swal.fire("Atención", "No hay notas seleccionadas para enviar.", "warning");
      return;
    }

    const resumen = datosAEnviar
      .slice(0, 5)
      .map((d) => `DNI: ${d.alumnoDni} → Nota: ${d.nota}`)
      .join("<br>");

    Swal.fire({
      title: "Confirmar envío",
      html: `
        <p>¿Seguro que quieres enviar las siguientes notas?</p>
        <div style="text-align:left;font-size:0.9rem;">
          ${resumen}
          ${datosAEnviar.length > 5 ? "<br>...y más" : ""}
        </div>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, enviar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.post(
            "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/enviaNotas/",
            { datos: datosAEnviar }
          );

          Swal.fire("Éxito", "Notas enviadas correctamente.", "success");
          cierro();
        } catch (error) {
          console.error("Error al enviar notas:", error);
          Swal.fire("Error", "Hubo un problema al enviar las notas.", "error");
        }
      }
    });
  };

  return (
    <div className="w-100">
      <div className="card shadow-sm w-100">
        <div className="card-body">
          {alumnos.length === 0 ? (
            <div className="alert alert-warning mt-4">
              No hay alumnos matriculados.
            </div>
          ) : (
            <>
              {esInstanciaFinal && (
                <div className="alert alert-info py-2">
                  Instancia final: se muestran todos los alumnos del aula para
                  calificar.
                </div>
              )}

              <div className="table-responsive mt-3 lm-tabla-scroll">
                <table className="table table-striped table-bordered align-middle">
                  <thead className="table-dark">
                    <tr>
                      <th>#</th>
                      <th>Apellido</th>
                      <th>Nombres</th>
                      <th>DNI</th>
                      <th style={{ minWidth: "160px" }}>Nota</th>
                    </tr>
                  </thead>

                  <tbody>
                    {alumnos.map((alumno, index) => (
                      <tr key={alumno.alumnoDni}>
                        <td>{index + 1}</td>
                        <td>{alumno.alumno.apellido}</td>
                        <td>{alumno.alumno.nombres}</td>
                        <td>{alumno.alumnoDni}</td>

                        <td>
                          <select
                            ref={(el) =>
                              (selectRefs.current[alumno.alumnoDni] = el)
                            }
                            className="form-select"
                            value={notas[alumno.alumnoDni] ?? ""}
                            onKeyDown={(e) =>
                              handleKeyDown(e, alumno.alumnoDni, index)
                            }
                            onChange={(e) =>
                              handleNotaChange(alumno.alumnoDni, e.target.value)
                            }
                          >
                            {idInstancia.tipoCalificacion === "Numerica" && (
                              <>
                                <option value="">Seleccionar</option>
                                {[...Array(11).keys()].map((num) => (
                                  <option key={num} value={num}>
                                    {num}
                                  </option>
                                ))}
                              </>
                            )}

                            {idInstancia.tipoCalificacion === "Aprobado" && (
                              <>
                                <option value="">Seleccionar</option>
                                <option value="Aprobado">Aprobado</option>
                                <option value="Reprobado">Reprobado</option>
                              </>
                            )}

                            {idInstancia.tipoCalificacion === "Regular" && (
                              <>
                                <option value="">Seleccionar</option>
                                <option value="Regular">Regular</option>
                                <option value="Libre">Libre</option>
                              </>
                            )}
                          </select>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="text-end mt-3">
                <button className="btn btn-primary" onClick={enviarDatos}>
                  Enviar Notas
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CalificadorSIGEDI;